import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className,
}) {
  return (
    <div
      className={cn(
        'text-center p-8 border rounded-lg bg-card',
        className
      )}
      role="status"
      aria-live="polite"
      data-testid="empty-state"
    >
      {Icon && (
        <div className="flex justify-center mb-4">
          <div className="p-3 rounded-full bg-muted">
            <Icon className="h-8 w-8 text-muted-foreground" />
          </div>
        </div>
      )}
      <h3 className="text-lg font-semibold">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground mt-1 max-w-sm mx-auto">
          {description}
        </p>
      )}
      {actionLabel && onAction && (
        <Button
          className="mt-4"
          onClick={onAction}
          data-testid="empty-state-primary-action"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}

export default EmptyState;
